import React from "react"
import { notification } from "antd"
import api from "src/api"

export function useManageItems(items, getItems, onSuccessEdit, onSuccessCreate) {
  const [editData, setEditData] = React.useState(null)

  function onEditItem(id) {
    setEditData(items.find((item) => item.id === id))
    onSuccessEdit()
  }

  async function onCreate(values) {
    try {
      await api.post("support-channels", values)
      notification.success({ message: "Канал добавлен" })
      onSuccessCreate()
      getItems()
    } catch (error) {
      console.log("Ошибка добавления", error)
      notification.error({ message: "Ошибка добавления" })
      throw error
    }
  }

  async function onSaveEdit(values, id) {
    try {
      await api.post(`support-channels/${id}`, values)
      notification.success({ message: "Канал изменен" })
      onSuccessEdit()
      resetData()
      getItems()
    } catch (error) {
      console.log("Ошибка изменения", error)
      notification.error({ message: "Ошибка изменения" })
      throw error
    }
  }

  /**
   * Переключатель видимости прямо из таблицы: канал нужно уметь скрывать
   * в один клик, не открывая форму.
   */
  async function onToggleActive(id, isActive) {
    const item = items.find((item) => item.id === id)
    if (!item) return

    const formData = new FormData()
    formData.append("_method", "PUT")
    formData.append("type", item.type)
    formData.append("link", item.link ?? "")
    formData.append("image", item.image ?? "")
    formData.append("isActive", isActive ? 1 : 0)
    formData.append("showInMobile", item.showInMobile ? 1 : 0)
    formData.append("showInSite", item.showInSite ? 1 : 0)
    formData.append("sortWeight", item.sortWeight ?? 0)
    ;(item.name ?? []).forEach((translation, index) => {
      formData.append(`name[${index}][language]`, translation.language)
      formData.append(`name[${index}][content]`, translation.content)
    })

    try {
      await api.post(`support-channels/${id}`, formData)
      notification.success({
        message: isActive ? "Канал показан клиентам" : "Канал скрыт",
      })
      getItems()
    } catch (error) {
      console.log("Ошибка изменения", error)
      notification.error({ message: "Ошибка изменения" })
    }
  }

  async function onDelete(id) {
    try {
      await api.delete(`support-channels/${id}`)
      notification.success({ message: "Канал удален" })
      getItems()
    } catch (error) {
      console.log("Ошибка удаления", error)
      notification.error({ message: "Ошибка удаления" })
      throw error
    }
  }

  function resetData() {
    setEditData(null)
  }

  return {
    editData,
    resetData,
    onSaveEdit,
    onCreate,
    onDelete,
    onEditItem,
    onToggleActive,
  }
}
